const theme = {
    colors: {
        primary: '#0f0f0f',
        secondary: '#ffffff',
        accent: '#000000', // Pure black for accent
        error: '#ef4444',
        lightGray: '#fafafa',
        darkGray: '#525252',
        text: '#171717',
        textLight: '#737373',
        border: '#f5f5f5',
        surface: '#ffffff',
        subtle: '#f9f9f9',
    },
    fonts: {
        primary: '"Inter", "Segoe UI", "Roboto", sans-serif',
        heading: '"Inter", sans-serif',
    },
    breakpoints: {
        mobile: '768px',
        tablet: '1024px',
        desktop: '1200px',
    },
    spacing: {
        xs: '0.5rem',
        sm: '1rem',
        md: '1.5rem',
        lg: '2rem',
        xl: '3rem',
        xxl: '4rem',
    },
    shadows: {
        light: '0 1px 2px rgba(0, 0, 0, 0.05)',
        medium: '0 1px 3px rgba(0, 0, 0, 0.1), 0 1px 2px rgba(0, 0, 0, 0.06)',
        heavy: '0 4px 6px rgba(0, 0, 0, 0.1), 0 2px 4px rgba(0, 0, 0, 0.06)',
        xl: '0 10px 15px rgba(0, 0, 0, 0.1), 0 4px 6px rgba(0, 0, 0, 0.05)',
    },
    transitions: {
        fast: '0.2s ease',
        normal: '0.3s ease',
        slow: '0.5s ease',
    },
};

export default theme;
